<template>
  <a-modal v-model="visible" title="单图" @ok="handleOk" width="660px">
    <TextbookMakerUpload :defaultUrl="img.src" :path="`textbook/${textbook.id}/${unit.folderName}/images/`" @changeImgUrl="(url) => changeImgUrl(url)"/>
</a-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import TextbookMakerUpload from '@/components/TextbookMakerUpload.vue'
export default {
  name: 'Thumb1',
  components: {
    TextbookMakerUpload
  },
  data() {
    return {
      visible: false,
      img: {
        src: undefined
      }
    }
  },
  computed: {
    ...mapState({
      textbook: (state) => {
        return state.textbookMaker.textbook
      },
      unit: (state) => {
        return state.textbookMaker.unit
      },
      lesson: (state) => {
        return state.textbookMaker.lesson
      },
    })
  },
  methods: {
    open() {
      this.visible = true
    },
    changeImgUrl(imgUrl) {
      console.log(imgUrl)
      this.img.src = imgUrl
    },
    handleOk() {
      console.log(this.img)
      let content = '<div class="fm_one_thumb mceNonEditable"><img src="' + this.img.src + '"/></div>'
      this.$emit('ok', {content: content, data: this.img})
      this.visible = false
    }
  }
}
</script>

<style>

</style>